<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iv"></a>
<p class="note1">Note</p>
<p class="note">All the characters and events of</p>
<p class="note">this story are fictitious</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Note.vue?6bff9df0